import AuthFormInputs from "./AuthFormInputs";

export default AuthFormInputs;
